/**
 * DBコンスト
 */

/*
 * BookingType
 */
// 予約種別
export const BOOKING_TYPE_ID_LIQUID_WASTE = 1;
export const BOOKING_TYPE_ID_DEPOSIT = 2;

/*
 * LiquidWastes
 */
/** 廃液ID（水銀） */
export const LIQUID_WASTES_ID_MERCURY: number = 10;